import React from 'react';
import { emit } from '../Socket/game.Emitters';
import { getHumanPlayerStandardIconPath, getBotPlayerStandardIconPath } from '../../env'
import { sessionUsername, sessionUsernameChangesRemaining } from '../Core/LoginManager'
import EditUsernamePopup from '../Popups/EditUsernamePopup';
import ConfirmationPopup from '../Popups/ConfirmationPopup';
import PlayerOptionsDropdown from './PlayerOptionsDropdown';
import { popup } from '../Utils/Popup';
import '../../css/playerOptionsDropdown.css';

class JoinedPlayers extends React.Component
{
  state = {
    showEditUsernameOverlay: false,
    openDropdownIndex: null,
  };

  componentDidMount()
  {
    document.addEventListener( 'mousedown', this.handleClickOutside );
  }

  componentWillUnmount()
  {
    document.removeEventListener( 'mousedown', this.handleClickOutside );
  }

  handleClickOutside = ( event ) =>
  {
    // Check if click is outside any dropdown
    if( !event.target.closest( '.player-options-dropdown' ) &&
      !event.target.closest( '.player-options-menu-button' ) )
    {
      this.setState( { openDropdownIndex: null } );
    }
  };

  onUsernameChangeClosed = ( newUsername ) =>
  {
    this.setState( { showEditUsernameOverlay: false } );
  };

  onPlayerColourChanged = ( playerIdx, colourID ) =>
  {
    emit.requestTeamColourChange( playerIdx, colourID );
  };

  handleDropdownToggle = ( index, event ) =>
  {
    event.stopPropagation();
    this.setState( {
      openDropdownIndex: this.state.openDropdownIndex === index ? null : index
    } );
  };

  handleDropdownClose = () =>
  {
    this.setState( { openDropdownIndex: null } );
  };

  handleEditUsername = () =>
  {
    this.setState( { showEditUsernameOverlay: true } );
  };

  handleKickPlayer = ( isBot, currentBotIndex, playerInfo ) =>
  {
    popup( <ConfirmationPopup
      title={ "Kick " + ( isBot ? "Bot" : "Player" ) }
      body={ "Want to kick out " + ( isBot ? "bot" : "" ) + " player '" + playerInfo.username + "'?" }
      buttonText={ "Kick" }
      onConfirm={ () =>
      {
        if( isBot )
        {
          emit.hostKickBotPlayer( currentBotIndex );
        }
        else
        {
          emit.hostKickHumanPlayer( playerInfo.userID );
        }
      } }
    /> );
  };

  render()
  {
    const { playersInRoom, clientId, maxPlayers, isRoomHost } = this.props;

    // console.log( "[DEBUG] PLAYERS JOINED ARE: ", playersInRoom );

    const playersList = [];
    let botIndex = 0;

    // Construct the player entry rows
    for( let idx = 0; idx < playersInRoom.length; idx++ )
    {
      let playerInfo = playersInRoom[ idx ];

      const isBot = playerInfo.isBot;
      const currentBotIndex = botIndex;
      const isClientEntry = !isBot && playerInfo.socketID === clientId;
      const keyValue = ( isBot ? "bot" + idx : playerInfo.id ) + "_" + idx;
      const isReady = isBot || playerInfo.isReady;

      playersList.push(
        <div className={ "room-setup-players-panel-list-entry room-details-player-block colour-dark-accent-bg " + ( isClientEntry ? "room-details-player-block-client-entry" : "" ) }
          key={ keyValue }
        >

          <img className="room-setup-player-block-profile-icon"
            src={ process.env.PUBLIC_URL + ( isBot ? getBotPlayerStandardIconPath( playerInfo.colourID ) : getHumanPlayerStandardIconPath( playerInfo.colourID ) ) }
            alt="Tilefolk profile icon" />
          {/* <img className="room-setup-player-block-profile-icon" src={process.env.PUBLIC_URL + '/avatars/meeple-' + playerInfo.colourID + '.png'} alt="Meeple Icon" /> */ }
          {/* { isBot && <img className="room-details-player-icon" src={process.env.PUBLIC_URL + '/ui/icon-bot.svg' } alt="Bot icon" /> } */ }

          <div className="room-setup-player-block-name-row">

            <span className='room-setup-player-block-name'>{ playerInfo.username }</span>

          </div>

          {
            !isBot &&
            <div className="room-setup-player-block-karma-score">
              { "Karma: " + playerInfo.karmaGamesCompleted + "/" + playerInfo.karmaGamesTotal }
            </div>
          }

          {/* Player Options Menu Button */ }
          { ( !isBot || isRoomHost || isClientEntry ) && (
            <button
              className="player-options-menu-button"
              onClick={ ( e ) => this.handleDropdownToggle( idx, e ) }
              aria-label="Player options"
            >
            </button>
          ) }

          {/* Dropdown Menu */ }
          { this.state.openDropdownIndex === idx && (
            <PlayerOptionsDropdown
              playerInfo={ playerInfo }
              isBot={ isBot }
              isRoomHost={ isRoomHost }
              isClientEntry={ isClientEntry }
              currentBotIndex={ currentBotIndex }
              onClose={ this.handleDropdownClose }
              onEditUsername={ this.handleEditUsername }
              onKickPlayer={ this.handleKickPlayer }
            />
          ) }


          { ( isClientEntry || ( isRoomHost && isBot ) ) &&
            <select
              className="room-setup-player-block-colour-select"
              defaultValue={ playerInfo.colourID }
              onChange={ ( e ) => { this.onPlayerColourChanged( idx, e.target.value ) } }
              onClick={ ( e ) => { e.stopPropagation(); } }
            >
              <option value="blue">Blue</option>
              <option value="red">Red</option>
              <option value="green">Green</option>
              <option value="yellow">Yellow</option>
              <option value="white">White</option>
              <option value="purple">Purple</option>
              <option value="black">Black</option>
              <option value="grey">Grey</option>
            </select>
          }

          {
            isReady &&
            <>
              <div className="room-setup-player-block-status-ready-text colour-success">Ready</div>
              <img className="room-setup-player-block-status-icon" src={ process.env.PUBLIC_URL + '/ui/icon-check.svg' } alt="Checked Icon" />
            </>
          }
          {
            !isReady &&
            <>
              <div className="room-setup-player-block-status-not-ready-text colour-warning">Not Ready</div>
              <img className="room-setup-player-block-status-icon" src={ process.env.PUBLIC_URL + '/ui/icon-x.svg' } alt="Checked Icon" />
            </>
          }

        </div>
      );

      if( isBot )
      {
        botIndex++;
      }
    }

    // Construct remaining empty player slots..
    for( var idx = playersInRoom.length; idx < maxPlayers; idx++ )
    {
      if( isRoomHost )
      {
        playersList.push(
          <div key={ "emptyPlayerSlot_" + idx } className="room-setup-players-panel-list-entry room-details-player-block-bot colour-dark-accent-bg">
            <button
              className='room-setup-players-panel-add-bot-button colour-success-bg'
              onClick={ () =>
              {
                emit.hostAddBotToRoom();
                // console.log("Add Bot");
              } }
            >
              Add Bot
            </button>
          </div>
        );
      }
      else
      {
        playersList.push(
          <div key={ "emptyPlayerSlot_" + idx } className="room-setup-players-panel-list-entry room-details-player-block" style={ { backgroundColor: 'rgba(0, 0, 0, 0.2)', opacity: 0.6 } }>
            <div className="room-setup-player-block-status-not-ready-text" style={ {
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              opacity: 0.7,
              fontStyle: 'italic',
              textAlign: 'center'
            } }>
              Empty
            </div>
          </div>
        );
      }

    }

    return (
      <div className="room-setup-players-panel rounded-floating-element colour-dark-shade-bg">
        <div className="room-setup-panel-title">
          Players ( { playersInRoom.length } / { maxPlayers } )
        </div>

        <div className="room-setup-players-panel-list">

          { playersList }

        </div>


        {
          this.state.showEditUsernameOverlay &&
          <EditUsernamePopup close={ this.onUsernameChangeClosed } value={ sessionUsername } changeUsername={ this.onUsernameChangeClosed } sessionUsernameChangesRemaining={ sessionUsernameChangesRemaining } />
        }
      </div>
    );
  }
}

export default JoinedPlayers;
